// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_Di8","cls2":"LoswpPackPitch-cls2_Ubz LoswpPackPitch-cls1_Di8"};